export enum BlogPageType {
  Article = 'ARTICLE',
  News = 'NEWS',
  Video = 'EXPERT_VIDEO'
}

export enum BlogPageTopic {
  TopFive = 'top-5',
  Wellness = 'wellness-dajdzhest',
  Interview = 'interv-ju'
}
